import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import { IAction, IAppState } from '../../../models/action/core';
import { IActivityCardItems } from '../../../models/components/activity-card';
import { IProcessingActivity } from '../../../models/components/processing-activity';
import { UserType } from '../../../models/pages/login.d';
import * as AnnouncementActions from '../../../store/actions/announcementPage';
import { Confirm } from '../../notification/main';
import { SenderState } from '../../../models/enums/senderState';
import Translator from '../../../core/i18n';

const T = Translator.create();
const _logger = Log.create('Processing Activity');
let _common: Common;

const SENT_TAB = '1';

class Processing extends React.Component<IProcessingActivity, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public deleteAnnouncementOnClick = () => {
        Confirm.setConfirm(
            'normal',
            this.deleteAnnouncementConfirmClick,
            T.t('r_delete_announcement_confirm'),
            null
        );
    };

    deleteAnnouncementConfirmClick = () => {
        this.props.dispatch(
            AnnouncementActions.getDeleteAnnouncement(
                { announcementId: this.props.updateAnnouncementId, senderState: SenderState.Deleted },
                'getDeleteActivityAction',
                'get',
                this.callback
            )
        );
    };

    public onClickItems(val: string) {
        switch (val) {
            case 'Edit': {
                if (this.props.updateAnnouncementId) {
                    this.props.dispatch(AnnouncementActions.getAnnouncementData(this.props.updateAnnouncementId, '', 'get', this.callback));
                }
                break;
            }
            default:
                break;
        }
    }

    callback = (val: string) => {
        switch (val) {
            case 'Edit': {
                if (this.props.modalTrigger && this.props.updateAnnouncementId) {
                    this.props.modalTrigger();
                }
                break;
            }
            case 'Delete': {
                this.props.dispatch(AnnouncementActions.getAnnouncementsAction(SENT_TAB, 'announcementList', 'get', 20, 0));
                if (this.props.selectedAnnouncement && this.props.selectedAnnouncement.length > 2) {
                    this.props.dispatch(
                        AnnouncementActions.getSelectedAnnouncementAction(
                            this.props.updateAnnouncementId === this.props.selectedAnnouncement[0].announcementId
                                ? this.props.selectedAnnouncement[1].announcementId
                                : this.props.selectedAnnouncement[0].announcementId,
                            'selectedAnnouncement',
                            'get'
                        )
                    );
                } else {
                    this.props.dispatch(AnnouncementActions.setSelectedAnnouncementDataDefault());
                }
                break;
            }
            default:
                break;
        }
    };

    public render() {
        return this.props.userType === UserType.Teacher ? (
            <React.Fragment>
                <div className="dropdown ml-2">
                    <a data-toggle="dropdown" href="javascript:;" aria-expanded="false" style={{ marginLeft: 187 }}>
                        <img src={_common.GetDefaultIcons('dots')} alt="Dots" />
                    </a>
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                            position: 'absolute',
                            transform: ' translate3d(-177px, 22px, 0px); top: 0px; left: 0px; will-change: transform'
                        }}
                    >
                        <a className="dropdown-item" onClick={this.onClickItems.bind(this, 'Edit')}>
                            {T.t('r_fileUpload_edit')}
                        </a>
                        <div className="dropdown-divider" />
                        <p
                            className="dropdown-item text-danger"
                            style={{ cursor: 'pointer' }}
                            onClick={this.deleteAnnouncementOnClick}
                        >
                            {T.t('r_gen_delete_announcement')}
                        </p>
                    </div>
                </div>
            </React.Fragment>
        ) : (
            ''
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IProcessingActivity): IProcessingActivity => {
    if (!state) {
        return ownProps;
    }

    const newProps: IProcessingActivity = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        selectedAnnouncement: state.announcement.announcements
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CProcessing = connect(
    mapStateToProps,
    dispatchProps
)(Processing);

export default CProcessing;
